export default "__VITE_ASSET__HA8lFAqm__"